import(/* webpackMode: "eager" */ "/vercel/path1/app/vocab/page.tsx");
